import baseApi from "./baseApi";
import axios from "axios";


const download = (r) => axios.get("File/Download/" + r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() }, responseType: 'blob' });

export default {
    download,
};